// extracted by mini-css-extract-plugin
export var dropdownButton = "_11-0";
export var fullWidthDropdownButton = "_11-1";
export var icon = "_11-3";
export var iconPlaceholder = "_11-2";
export var menuItemRow = "_11-9";
export var separator = "_11-e";
export var shortcutContainer = "_11-7";
export var shortcutContainerFilled = "_11-8";
export var shortcutIconLg = "_11-6";
export var shortcutIconMd = "_11-5";
export var shortcutIconSm = "_11-4";
export var submenuChevron = "_11-d";
export var submenuDropdown = "_11-a";
export var submenuTriggerRow = "_11-b";
export var submenuTriggerRowOpen = "_11-c";